import { render, staticRenderFns } from "./CurrencyNew.vue?vue&type=template&id=d24d2518&"
import script from "./CurrencyNew.vue?vue&type=script&lang=js&"
export * from "./CurrencyNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports